import { Tabs, TabsProps, Tab, TabProps } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledTabs = styled((props: TabsProps) => <Tabs {...props} />)(
  () => ({
    minHeight: '40px',
    '& .MuiTabs-indicator': {
      display: 'none',
    },
  }),
);

export const StyledTab = styled((props: TabProps) => (
  <Tab
    disableRipple
    {...props}
  />
))(({ theme }) => ({
  padding: '8px 16px',
  marginRight: theme.spacing(1),
  textTransform: 'none',
  fontWeight: 600,
  fontSize: '14px',
  color: theme.palette.text.secondary,
  backgroundColor: 'transparent',
  borderRadius: '8px',
  minHeight: '40px',
  height: '40px',
  flexShrink: 0,
  flexGrow: 1,
  whiteSpace: 'nowrap',
  '&.Mui-selected': {
    backgroundColor: theme.palette.custom.overlay.selected,
    color: theme.palette.primary.main,
  },
}));

export default { StyledTabs, StyledTab };
